/**
 * topdog-page.js
 *
 * TopDog strategy — across Weekly, Daily, 4H:
 *   Long:  Rising 50 SMA · Stoch(5,2,3) %K < 75 · MACD(5,20,30) signal rising
 *   Short: Falling 50 SMA · Stoch(5,2,3) %K > 75 · MACD(5,20,30) signal falling
 */

import React from 'react';
import StrategySignalsPage from './strategy-signals-page';
import { fetchTopDogData } from '../services/server-api';

const TF_LABELS = { weekly: 'Weekly', daily: 'Daily', fourHour: '4H' };

function renderDetails(entry) {
  const stochKVal  = entry.stochFastK != null ? entry.stochFastK.toFixed(1) : '—';
  const slopeLabel = entry.sma50Slope === 'up' ? '↑ rising' : '↓ falling';
  return (
    <>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">50 SMA</span>
        <span className={`mtf-ind-value ${entry.state === 'long' ? 'bull' : 'bear'}`}>{slopeLabel}</span>
      </div>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">Stoch(5,2,3) %K</span>
        <span className="mtf-ind-value zone">{stochKVal}</span>
      </div>
    </>
  );
}

function TopDogPage() {
  return (
    <StrategySignalsPage
      config={{
        title:      'ProjectTD',
        icon:       '🐕',
        subtitle:   'Rising/falling 50 SMA · Stoch(5,2,3) %K < 25 (long) / > 75 (short)',
        fetchFn:    fetchTopDogData,
        timeframes: ['weekly', 'daily', 'fourHour'],
        tfLabels:   TF_LABELS,
        renderDetails,
      }}
    />
  );
}

export default TopDogPage;
